import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_API_URL;
const SOCKET_URL = API_URL ? API_URL.replace(/\/api\/v\d+\/?.*$/, "") : "";

// Module-level singleton — one socket for the whole app session
let _socket = null;

export const getSocket = () => {
  if (_socket) return _socket;

  const token = localStorage.getItem("token");
  if (!token || !SOCKET_URL) return null;

  _socket = io(SOCKET_URL, {
    auth: { token },
    query: { token },
    transports: ["polling", "websocket"],
    withCredentials: false,
  });

  _socket.on("connect", () => console.log("[Socket] Connected:", _socket.id));
  _socket.on("disconnect", (r) => console.warn("[Socket] Disconnected:", r));

  return _socket;
};

export const destroySocket = () => {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
};
